import { Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { getUser } from '../../../shared/authValidation';
import Button from '../../../components/CustomButtons/Button';
import { get } from 'lodash';
import ERTLSubTab from './DocumentFolders/ERTLSubTab';
import ListingSubmissionSubTab from './DocumentFolders/ListingSubmissionSubTab';
import TenantRepSubTab from './DocumentFolders/TenantRepSubTab';
import CommissionSplitsSubTab from './DocumentFolders/CommissionSplitsSubTab';
import RSSubTab from './DocumentFolders/RSSubTab';
import PMASubTab from './DocumentFolders/PMASubTab';
import InvoiceSubTab from './DocumentFolders/InvoiceSubTab';

const StyledTab = withStyles({
  root: {
    minWidth: 100,     // default is 72, reduce this
    // width: 60,        // custom width
    padding: 0,
    fontSize: '0.75rem'
  }
})(Tab);

const PropertiesDocuments = (props) => {
    const user = getUser();
    const perms = user.permObj
        ? Array.from(new Set(
            Object.keys(user.permObj).map(f => f.split(' ')[0])
            ))
        : [];
    const permsAll = Object.keys(user.permObj);
    console.log('perms', perms, permsAll);
    const [subTab, setSubTab] = useState('');

    const tabData = {
    'ERTL': {
        index: 0,
        icon: <strong style={{fontSize:20}}>E</strong>,
        name: 'ERTL',
        link: ''
    },
    'Listing Submission Form': {
        index: 1,
        icon: <strong style={{fontSize:20}}>LS</strong>,
        name: 'Listing Submission',
        link: ''
    },
    'Tenant Rep Form': {
        index: 2,
        icon: <strong style={{fontSize:20}}>TR</strong>,
        name: 'Tenant Rep',
        link: ''
    },
    'Commission Splits Form': {
        index: 3,
        icon: <strong style={{fontSize:20}}>CS</strong>,
        name: 'Commission Splits',
        link: ''
    },
    'Routing Sheet': {
        index: 4,
        icon: <strong style={{fontSize:20}}>RS</strong>,
        name: 'Routing Sheet',
        link: ''
    },
    'PMA': {
        index: 5,
        icon: <strong style={{fontSize:20}}>P</strong>,
        name: 'PMA',
        link: ''
    },
    'Invoices': {
        index: 6,
        icon: <strong style={{fontSize:20}}>I</strong>,
        name: 'Invoice',
        link: ''
    }
  }

  const theTabs = Object.keys(tabData).filter(f => {
    if (f === 'ERTL' && perms.indexOf('ERTL') !== -1) return true;
    if (f === 'Listing Submission Form' && perms.indexOf('Listing') !== -1) return true;
    if (f === 'Tenant Rep Form' && perms.indexOf('TR') !== -1) return true;
    if (f === 'Commission Splits Form' && perms.indexOf('CommissionSplits') !== -1) return true;
    if (f === 'Routing Sheet' && perms.indexOf('Routing') !== -1) return true;
    if (f === 'PMA' && perms.indexOf('PMA') !== -1) return true;
    if (f === 'Invoices' && perms.indexOf('Invoice') !== -1) return true;
  });
  console.log('PropertiesDocuments', props);
  const property_id = get(props, 'dataObj.id', null);
  if (!property_id) return null;
  return (
    <div className="properties-documents">
        <Tabs
            TabIndicatorProps={{
                style: {
                    background: "#da3b2f",
                    borderBottom: "1px solid #da3b2f",
                    color: "#da3b2f",
                },
            }}
            style={{ marginBottom: 10 }}
            value={tabData[subTab] ? tabData[subTab].index : false}
        >   
            {theTabs.map((tabName,i) => {
                return <StyledTab
                    key={`subtab-${i}`}
                    onClick={() => {
                        setSubTab(tabName);
                    }}
                    style={{
                        color: tabData[subTab]?.index === i ? "#da3b2f" : "rgba(0, 0, 0, 0.87)",
                    }}
                    tabIndex={tabData[subTab]?.index}
                    label={tabName}
                    icon={tabData[tabName]?.icon}
                />
            })}
        </Tabs>
        {/* 
        1.ERTL
        2.Listing Submission Form
        3.Tenant Rep Form
        4.Commission Splits Form
        5.Routing Sheet
        6.PMA
        7.Invoices 
        */}

        {Object.keys(tabData).map(subTabName => {
            if (subTabName !== subTab) return null;
            return <div key={`${subTabName}-tidal`}>
                    {subTabName === 'ERTL' && <ERTLSubTab 
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
                    {subTabName === 'Listing Submission Form' && <ListingSubmissionSubTab
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
                    {subTabName === 'Tenant Rep Form' && <TenantRepSubTab
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
                    {subTabName === 'Commission Splits Form' && <CommissionSplitsSubTab
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
                    {subTabName === 'Routing Sheet' && <RSSubTab
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
                    {subTabName === 'PMA' && <PMASubTab
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
                    {subTabName === 'Invoices' && <InvoiceSubTab
                        property_id={property_id}
                        perms={perms}
                        permsAll={permsAll}
                    />}
            </div>
        })}

    </div>
  );
};

export default PropertiesDocuments;
